import styled from "styled-components/macro";

const Gap = styled.div`
  width: 100%;
  height: ${(p) => p.height * 4}px;
`;

export default Gap;
